import * as React from 'react';
import { Box, Button } from '@leagueplatform/genesis-core';
import {
  MenuItem,
  SelectActionMenu,
  SelectMenuItemGroup,
} from '@web-config-app/core-react-ui';

export interface CombinatorArrayAddActionMenuProps {
  buttonLabel: string;
  menuItems: MenuItem[];
  onSelectItem: (itemId: string) => void;
  disabled?: boolean;
}

export const CombinatorArrayAddActionMenu: React.FC<
  CombinatorArrayAddActionMenuProps
> = ({ buttonLabel, menuItems, onSelectItem, disabled }) => {
  const menuGroups = React.useMemo(() => {
    const groups: SelectMenuItemGroup[] = [
      {
        menuItems: menuItems.map((item) => ({
          id: item.id,
          label: item.label,
          action: () => onSelectItem(item.id),
        })),
      },
    ];

    return groups;
  }, [menuItems, onSelectItem]);

  return (
    <Box css={{ marginBlockStart: '$one' }}>
      <SelectActionMenu menuGroups={menuGroups}>
        <Button
          icon="interfacePlus"
          size="medium"
          priority="secondary"
          disabled={disabled}
        >
          {buttonLabel}
        </Button>
      </SelectActionMenu>
    </Box>
  );
};
